import React, {Component} from 'react';

class ExpandableLI extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expand: false
        };
    }

    toggleExpand = ()=> {
        const { item } = this.props
        if (this.props.onClick) {
            this.props.onClick(!!this.state.expand, item);
        }
        this.setState({
            expand: !this.state.expand
        })
    }

    render(){
        const expandable = this.state.expand ? <p dangerouslySetInnerHTML={{ __html: this.props.expandText}} className="expandable"/> : null;
        return (
            <li className="expandable-LI">
                <div className="list-item" onClick={this.toggleExpand}>
                    <span className="bullet">{this.props.bullet}</span>
                    <div className={'icon ' + (this.state.expand? 'rotate-x ': ' ' )+ (this.props.plusColor || '')}/>
                </div>
                {expandable}
            </li>
        );
    }
}

export default ExpandableLI;